<template>
  <div v-if="owner === 'drr'">
    <b-row>
      <!-- menu ภาพรวม -->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button>
          <b-link to="/">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M15.3333 27.3333H23.3333C24.0667 27.3333 24.6667 26.7333 24.6667 26V15.3333C24.6667 14.6 24.0667 14 23.3333 14H15.3333C14.6 14 14 14.6 14 15.3333V26C14 26.7333 14.6 27.3333 15.3333 27.3333ZM15.3333 38H23.3333C24.0667 38 24.6667 37.4 24.6667 36.6667V31.3333C24.6667 30.6 24.0667 30 23.3333 30H15.3333C14.6 30 14 30.6 14 31.3333V36.6667C14 37.4 14.6 38 15.3333 38ZM28.6667 38H36.6667C37.4 38 38 37.4 38 36.6667V26C38 25.2667 37.4 24.6667 36.6667 24.6667H28.6667C27.9333 24.6667 27.3333 25.2667 27.3333 26V36.6667C27.3333 37.4 27.9333 38 28.6667 38ZM27.3333 15.3333V20.6667C27.3333 21.4 27.9333 22 28.6667 22H36.6667C37.4 22 38 21.4 38 20.6667V15.3333C38 14.6 37.4 14 36.6667 14H28.6667C27.9333 14 27.3333 14.6 27.3333 15.3333Z"
                fill="url(#paint0_linear_1_2)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1_2"
                  x1="26"
                  y1="14"
                  x2="26"
                  y2="38"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#99FBCA" />
                  <stop
                    offset="0.461458"
                    stop-color="#00B058"
                  />
                </linearGradient>
              </defs>
              <foreignObject
                x="80"
                y="13"
                width="100"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>ภาพรวม</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>

      <!-- menu ปริมาณจราจร -->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button>
          <b-link to="/counting-total">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-10"
                y="12"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="30"
                  height="26"
                  viewBox="0 0 30 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M28.158 9.12764L26.106 3.54164C25.8083 2.72835 25.2358 2.02087 24.4697 1.51972C23.7036 1.01857 22.7829 0.74924 21.8385 0.750002H8.1615C7.21708 0.74924 6.29642 1.01857 5.53033 1.51972C4.76423 2.02087 4.19167 2.72835 3.894 3.54164L1.842 9.12764C1.29633 9.33482 0.830341 9.68375 0.5026 10.1306C0.17486 10.5774 -7.2135e-07 11.1021 0 11.6389V18.4444C0 19.4489 0.606 20.3173 1.5 20.7896V23.8889C1.5 24.2499 1.65804 24.5961 1.93934 24.8513C2.22064 25.1066 2.60218 25.25 3 25.25H4.5C4.89782 25.25 5.27936 25.1066 5.56066 24.8513C5.84196 24.5961 6 24.2499 6 23.8889V21.1667H24V23.8889C24 24.2499 24.158 24.5961 24.4393 24.8513C24.7206 25.1066 25.1022 25.25 25.5 25.25H27C27.3978 25.25 27.7794 25.1066 28.0607 24.8513C28.342 24.5961 28.5 24.2499 28.5 23.8889V20.7896C28.9551 20.5528 29.3334 20.2113 29.5967 19.7996C29.86 19.3879 29.9991 18.9205 30 18.4444V11.6389C30 11.1021 29.8251 10.5774 29.4974 10.1306C29.1697 9.68375 28.7037 9.33482 28.158 9.12764ZM8.1615 3.47222H21.837C22.4835 3.47222 23.0565 3.84517 23.2605 4.40322L24.9195 8.91667H5.0805L6.738 4.40322C6.83752 4.13208 7.02858 3.89624 7.28407 3.72914C7.53957 3.56204 7.84655 3.47215 8.1615 3.47222V3.47222ZM5.25 17.0833C4.95443 17.0832 4.66177 17.0303 4.38873 16.9276C4.1157 16.8249 3.86763 16.6744 3.6587 16.4847C3.44977 16.2949 3.28406 16.0698 3.17104 15.8219C3.05802 15.5741 2.9999 15.3085 3 15.0403C3.0001 14.7721 3.05841 14.5065 3.17161 14.2588C3.28482 14.011 3.45069 13.7859 3.65976 13.5963C3.86883 13.4068 4.11701 13.2564 4.39012 13.1538C4.66323 13.0513 4.95593 12.9985 5.2515 12.9986C5.84844 12.9988 6.42084 13.2142 6.8428 13.5973C7.26476 13.9805 7.5017 14.5 7.5015 15.0417C7.5013 15.5833 7.26398 16.1027 6.84174 16.4856C6.4195 16.8685 5.84694 17.0835 5.25 17.0833V17.0833ZM24.75 17.0833C24.4544 17.0832 24.1618 17.0303 23.8887 16.9276C23.6157 16.8249 23.3676 16.6744 23.1587 16.4847C22.9498 16.2949 22.7841 16.0698 22.671 15.8219C22.558 15.5741 22.4999 15.3085 22.5 15.0403C22.5001 14.7721 22.5584 14.5065 22.6716 14.2588C22.7848 14.011 22.9507 13.7859 23.1598 13.5963C23.3688 13.4068 23.617 13.2564 23.8901 13.1538C24.1632 13.0513 24.4559 12.9985 24.7515 12.9986C25.3484 12.9988 25.9208 13.2142 26.3428 13.5973C26.7648 13.9805 27.0017 14.5 27.0015 15.0417C27.0013 15.5833 26.764 16.1027 26.3417 16.4856C25.9195 16.8685 25.3469 17.0835 24.75 17.0833V17.0833Z"
                    fill="url(#paint0_linear_584_11112)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_584_11112"
                      x1="15"
                      y1="0.75"
                      x2="15"
                      y2="25.25"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#F2B7B7" />
                      <stop
                        offset="0.520833"
                        stop-color="#B70808"
                      />
                      <stop
                        offset="0.890625"
                        stop-color="#872000"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="65"
                y="13"
                width="120"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>ปริมาณจราจร</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>

      <!-- menu Analytic รวม-->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button style="background-color: rgba(0, 176, 88, 0.7);">
          <b-link to="/analytic120-total">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-10"
                y="10"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.1111 3H5.88889C4.3 3 3 4.3 3 5.88889V26.1111C3 27.7 4.3 29 5.88889 29H26.1111C27.7 29 29 27.7 29 26.1111V5.88889C29 4.3 27.7 3 26.1111 3ZM10.2222 23.2222C9.42778 23.2222 8.77778 22.5722 8.77778 21.7778V17.4444C8.77778 16.65 9.42778 16 10.2222 16C11.0167 16 11.6667 16.65 11.6667 17.4444V21.7778C11.6667 22.5722 11.0167 23.2222 10.2222 23.2222ZM16 23.2222C15.2056 23.2222 14.5556 22.5722 14.5556 21.7778V20.3333C14.5556 19.5389 15.2056 18.8889 16 18.8889C16.7944 18.8889 17.4444 19.5389 17.4444 20.3333V21.7778C17.4444 22.5722 16.7944 23.2222 16 23.2222ZM16 16C15.2056 16 14.5556 15.35 14.5556 14.5556C14.5556 13.7611 15.2056 13.1111 16 13.1111C16.7944 13.1111 17.4444 13.7611 17.4444 14.5556C17.4444 15.35 16.7944 16 16 16ZM21.7778 23.2222C20.9833 23.2222 20.3333 22.5722 20.3333 21.7778V10.2222C20.3333 9.42778 20.9833 8.77778 21.7778 8.77778C22.5722 8.77778 23.2222 9.42778 23.2222 10.2222V21.7778C23.2222 22.5722 22.5722 23.2222 21.7778 23.2222Z"
                    fill="url(#paint0_linear_1193_14784)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_1193_14784"
                      x1="16"
                      y1="3"
                      x2="16"
                      y2="29"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#F4FF76" />
                      <stop
                        offset="1"
                        stop-color="#2BC028"
                      />
                    </linearGradient>
                  </defs>
                </svg>
              </foreignObject>
              <foreignObject
                x="65"
                y="13"
                width="120"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>Analytic</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>

      <!-- menu กล้องวงจรปิด -->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button>
          <b-link to="/cctv-total">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-10"
                y="9"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    y="23.2725"
                    width="3.88746"
                    height="8.72727"
                    rx="0.5"
                    fill="url(#paint0_linear_584_11129)"
                  />
                  <path
                    d="M4.85938 26.1816H6.3031C6.57925 26.1816 6.8031 26.4055 6.8031 26.6816V29.5604C6.8031 29.8366 6.57925 30.0604 6.3031 30.0604H4.85938V26.1816Z"
                    fill="url(#paint1_linear_584_11129)"
                  />
                  <path
                    d="M27.5701 14.5459L28.9266 15.0385C29.1862 15.1328 29.3199 15.4195 29.2252 15.6789L27.9059 19.2956C27.8113 19.555 27.5242 19.6889 27.2646 19.5946L25.9081 19.102L27.5701 14.5459Z"
                    fill="url(#paint2_linear_584_11129)"
                  />
                  <path
                    d="M17.0076 18.4238L16.8857 18.8776C16.8141 19.1443 16.5398 19.3027 16.273 19.2313L12.5453 18.2347C12.2785 18.1634 12.1203 17.8894 12.192 17.6227L12.3138 17.1689L17.0076 18.4238Z"
                    fill="url(#paint3_linear_584_11129)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.0834 19.8955L13.2059 19.3936L11.0877 27.1511H7.7749V29.0905H11.6624L11.6624 29.0905L12.6343 29.0905L15.0834 19.8955Z"
                    fill="url(#paint4_linear_584_11129)"
                  />
                  <path
                    d="M5.62427 4.84863L27.5424 12.8084L25.0049 19.7644C24.9103 20.0238 24.6232 20.1577 24.3636 20.0634L4.79537 12.957C3.75714 12.58 3.22235 11.4331 3.60088 10.3954L5.62427 4.84863Z"
                    fill="url(#paint5_linear_584_11129)"
                  />
                  <path
                    d="M6.47419 1.88249C6.85323 0.843404 8.00414 0.308061 9.04305 0.687599L31.9828 9.06806L27.9538 11.4821C27.8245 11.5596 27.6672 11.5747 27.5255 11.5233L5.8313 3.64487L6.47419 1.88249Z"
                    fill="url(#paint6_linear_584_11129)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_584_11129"
                      x1="1.94373"
                      y1="23.2725"
                      x2="1.94373"
                      y2="31.9997"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#B5C1FF" />
                      <stop
                        offset="1"
                        stop-color="#004CEC"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_584_11129"
                      x1="5.83124"
                      y1="26.1816"
                      x2="5.83124"
                      y2="30.0604"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#B5C0FF" />
                      <stop
                        offset="1"
                        stop-color="#1D56AC"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_584_11129"
                      x1="28.4833"
                      y1="14.8776"
                      x2="26.8279"
                      y2="19.436"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#B5C1FF" />
                      <stop
                        offset="1"
                        stop-color="#004CEC"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint3_linear_584_11129"
                      x1="15.5"
                      y1="16.9995"
                      x2="14.4972"
                      y2="19.4984"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#B5C0FF" />
                      <stop
                        offset="1"
                        stop-color="#004CEC"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint4_linear_584_11129"
                      x1="11.4291"
                      y1="19.3936"
                      x2="11.4291"
                      y2="29.0905"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#B5C1FF" />
                      <stop
                        offset="1"
                        stop-color="#004CEC"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint5_linear_584_11129"
                      x1="16.5833"
                      y1="8.8285"
                      x2="13.8852"
                      y2="16.2581"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#B5C0FF" />
                      <stop
                        offset="1"
                        stop-color="#004CEC"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint6_linear_584_11129"
                      x1="19.5805"
                      y1="4.51027"
                      x2="18.2561"
                      y2="8.15704"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#B5C0FF" />
                      <stop
                        offset="1"
                        stop-color="#1D56AC"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="65"
                y="13"
                width="120"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>กล้องวงจรปิด</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>

      <!-- menu ป้าย VMS -->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button>
          <b-link to="/vms-total">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-10"
                y="12"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="28"
                  height="24"
                  viewBox="0 0 28 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.895431 24 2 24H26C27.1046 24 28 23.1046 28 22V2C28 0.895431 27.1046 0 26 0H2ZM15 2.5H12V7.5727H5.45205V4.89998L2 9.09998L5.45205 13.3V10.6272L12 10.6272V21.7H15V16.6272H22.5479V19.3L26 15.1L22.5479 10.9V13.5727H15V2.5Z"
                    fill="url(#paint0_linear_584_11155)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_584_11155"
                      x1="14"
                      y1="22.3"
                      x2="14"
                      y2="3.1"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop
                        offset="0.3125"
                        stop-color="#8246FE"
                      />
                      <stop
                        offset="1"
                        stop-color="#D2BDFD"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="65"
                y="13"
                width="120"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>ป้าย VMS</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>

      <!-- menu ทางม้าลาย -->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button>
          <b-link to="/crosswalk-total">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                width="100%"
                height="100%"
                x="-55"
                y="5"
              >
                <div>
                  <b-img
                    height="40"
                    src="@/assets/images/icons/crosswalk/Crosswalkicon.png"
                  />
                </div>
              </foreignObject>
              <foreignObject
                x="60"
                y="13"
                width="120"
                height="150"
                color="#D3D3D3"
                font-size="17"
              >
                <div>
                  <strong>ทางข้ามม้าลาย</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>

      <!-- menu ระบบแสงสว่าง -->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button>
          <!-- /lighting-sub?DeptID=98 -->
          <!-- /semcontrol-total -->
          <b-link to="/semcontrol-total">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-10"
                y="10"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4667 28.1338C14.4667 29.1605 15.3067 30.0005 16.3333 30.0005C17.36 30.0005 18.2 29.1605 18.2 28.1338H14.4667Z"
                    fill="#E17A00"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.3014 23.4667H13.02C12.6518 21.4875 11.421 19.5537 10.1337 17.531L10.08 17.4467C10.0468 17.3938 10.0136 17.3408 9.98029 17.2878C8.51691 14.9567 7 12.5404 7 10.2133C7 5.68667 11.2 2 16.3333 2C21.4667 2 25.6667 5.68667 25.6667 10.2133C25.6667 12.5933 24.08 15.0667 22.54 17.4467L22.4863 17.5311C21.199 19.5537 19.9682 21.4875 19.6 23.4667H17.3419C17.4695 22.9769 17.6229 22.4304 17.7913 21.8307C18.0217 21.0105 18.28 20.0907 18.5383 19.08C18.639 18.6133 18.7901 18.1 18.9412 17.5867C18.9664 17.4467 19.0041 17.3067 19.0419 17.1667C19.0797 17.0267 19.1174 16.8867 19.1426 16.7467C19.5455 16.7 19.898 16.6067 20.1498 16.3733C20.4519 16.0933 20.603 15.7667 20.5023 15.3933C20.4519 15.2067 20.3512 14.9733 20.049 14.9267C19.898 14.88 19.7973 14.88 19.6462 14.9267C19.4951 14.9733 19.3944 15.0667 19.344 15.1133C19.0923 15.3933 18.9915 15.6733 18.8908 15.9533L18.7398 16.3733C18.7398 16.3733 18.3369 16.42 17.3801 15.8133C17.0002 15.5669 16.8209 15.3735 16.6909 15.2333C16.6486 15.1877 16.6115 15.1477 16.5744 15.1133C16.6248 15.0511 16.6751 14.9941 16.7255 14.937C16.8262 14.823 16.9269 14.7089 17.0276 14.5533C17.0444 14.5067 17.0612 14.4652 17.078 14.4237C17.1115 14.3407 17.1451 14.2578 17.1787 14.1333C17.1787 13.9933 17.1787 13.8067 17.078 13.6667C16.9773 13.5267 16.8765 13.3867 16.6248 13.2933C16.524 13.2467 16.4233 13.2467 16.3226 13.2467C16.2219 13.2467 16.1212 13.2467 16.0205 13.2933C15.819 13.3867 15.668 13.5267 15.5673 13.6667C15.4665 13.8067 15.4665 13.9933 15.4665 14.1333C15.4665 14.2733 15.5169 14.4133 15.6176 14.5533C15.7183 14.7867 15.8694 14.9733 16.0708 15.1133C16.0337 15.1477 15.9967 15.1877 15.9543 15.2333C15.8243 15.3735 15.6451 15.5669 15.2651 15.8133C14.3587 16.3733 13.9055 16.3733 13.9055 16.3733L13.7544 15.9533C13.6537 15.6733 13.553 15.3933 13.3012 15.1133C13.2508 15.0667 13.1501 14.9733 12.9991 14.9267C12.848 14.88 12.6969 14.88 12.5962 14.9267C12.2941 15.02 12.1933 15.2533 12.143 15.3933C12.0926 15.7667 12.2437 16.0933 12.4955 16.3733C12.7976 16.6067 13.1501 16.7 13.5026 16.7467C13.5278 16.8867 13.5656 17.0267 13.6033 17.1667C13.6411 17.3067 13.6789 17.4467 13.7041 17.5867C13.7796 17.8433 13.8425 18.0883 13.9055 18.3333C13.9684 18.5783 14.0314 18.8233 14.1069 19.08C14.5541 20.8298 14.9523 22.3069 15.3014 23.4667ZM15.6075 23.4667C15.3565 22.3057 15.0073 20.7831 14.5601 19.0333C14.5164 18.8308 14.4632 18.6195 14.4088 18.4032C14.3378 18.1211 14.2646 17.8305 14.2076 17.54C14.2006 17.5073 14.1935 17.4737 14.1863 17.4395C14.1422 17.2291 14.0928 16.994 14.0062 16.7933C14.4091 16.7 15.3658 16.42 16.3226 15.44C17.2794 16.42 18.2362 16.7 18.639 16.7933C18.5887 17.0733 18.5383 17.3067 18.4376 17.54C18.3806 17.8305 18.3075 18.1211 18.2365 18.4032C18.182 18.6195 18.1288 18.8308 18.0851 19.0333C17.6379 20.7831 17.2888 22.3057 17.0377 23.4667H15.6075ZM15.6075 23.4667C15.6109 23.4823 15.6143 23.4978 15.6176 23.5133H15.3155C15.3108 23.4978 15.3061 23.4823 15.3014 23.4667H15.6075ZM17.0377 23.4667H17.3419C17.3378 23.4823 17.3338 23.4978 17.3298 23.5133H17.0276C17.031 23.4978 17.0343 23.4823 17.0377 23.4667ZM19.3773 15.9684C19.3662 15.9949 19.3551 16.021 19.344 16.0467C19.2937 16.14 19.2937 16.2333 19.2937 16.3733V16.3733C19.4951 16.3267 19.6965 16.2333 19.8476 16.14C20.049 16 20.1498 15.72 20.0994 15.5333C20.049 15.3933 19.9987 15.3467 19.9483 15.3467H19.8476C19.8476 15.3467 19.7973 15.3467 19.7469 15.3933C19.5676 15.518 19.4681 15.7535 19.3773 15.9684ZM16.3226 13.62C16.2219 13.62 16.1212 13.7133 16.0205 13.8067C15.9198 13.9933 15.9701 14.18 16.0708 14.32C16.1062 14.4182 16.1663 14.4935 16.2338 14.578C16.2625 14.6139 16.2926 14.6515 16.3226 14.6933C16.4233 14.6 16.524 14.46 16.5744 14.32C16.6751 14.1333 16.7255 13.9467 16.6248 13.8067C16.524 13.6667 16.4233 13.62 16.3226 13.62ZM12.7473 15.2533C12.6466 15.3 12.5962 15.3467 12.5962 15.44C12.5962 15.6733 12.6969 15.9067 12.8983 16C13.0494 16.14 13.2508 16.1867 13.4523 16.2333C13.4271 16.1867 13.4145 16.14 13.4019 16.0933C13.3893 16.0467 13.3767 16 13.3516 15.9533C13.2508 15.72 13.0998 15.44 12.9487 15.3C12.8983 15.3 12.848 15.2533 12.848 15.2533H12.7473Z"
                    fill="url(#paint0_linear_584_11232)"
                  />
                  <path
                    d="M13.02 24.4004H19.6934V25.2404H13.02V24.4004ZM13.4867 26.0804H19.2267V26.9204H13.4867V26.0804Z"
                    fill="#FFD7A7"
                  />
                  <path
                    d="M13.4867 25.2402H19.2267V26.0802H13.4867V25.2402Z"
                    fill="#E17A00"
                  />
                  <path
                    d="M19.6934 24.4004L13.4867 26.0804V26.9671L19.6934 25.2404V24.4004ZM13.9534 27.8071H18.76V28.6471H13.9534V27.8071Z"
                    fill="#FFD7A7"
                  />
                  <path
                    d="M13.9533 26.9668H18.76V27.8068H13.9533V26.9668Z"
                    fill="#E17A00"
                  />
                  <path
                    d="M19.2266 26.0801L13.9533 27.8067V28.6934L19.2266 26.9667V26.0801Z"
                    fill="#FFD7A7"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_584_11232"
                      x1="16.3333"
                      y1="2"
                      x2="16.3333"
                      y2="23.5133"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFD7A7" />
                      <stop
                        offset="0.489583"
                        stop-color="#E17A00"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="65"
                y="13"
                width="120"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>ระบบแสงสว่าง</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>

      <!-- menu ป้ายจราจร -->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button style="background-color: rgba(0, 0, 0, 0.2);">
          <b-link to="traffic-total">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-28"
                y="10"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="32"
                  height="28"
                  viewBox="0 0 32 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5143 0C8.49715 0 6.85715 1.56953 6.85715 3.5V19.25C6.85715 24.0844 10.9486 28 16 28C21.0514 28 25.1429 24.0844 25.1429 19.25V3.5C25.1429 1.56953 23.5029 0 21.4857 0H10.5143ZM16 17.5C17.5143 17.5 18.7429 18.6758 18.7429 20.125C18.7429 21.5742 17.5143 22.75 16 22.75C14.4857 22.75 13.2571 21.5742 13.2571 20.125C13.2571 18.6758 14.4857 17.5 16 17.5ZM13.2571 13.125C13.2571 11.6758 14.4857 10.5 16 10.5C17.5143 10.5 18.7429 11.6758 18.7429 13.125C18.7429 14.5742 17.5143 15.75 16 15.75C14.4857 15.75 13.2571 14.5742 13.2571 13.125ZM16 3.5C17.5143 3.5 18.7429 4.67578 18.7429 6.125C18.7429 7.57422 17.5143 8.75 16 8.75C14.4857 8.75 13.2571 7.57422 13.2571 6.125C13.2571 4.67578 14.4857 3.5 16 3.5Z"
                    fill="url(#paint0_linear_584_11180)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_584_11180"
                      x1="16"
                      y1="0"
                      x2="16"
                      y2="28"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FE8592" />
                      <stop
                        offset="0.588542"
                        stop-color="#FB0000"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="36"
                y="13"
                width="150"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>ไฟจราจรอัจฉริยะ</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>
      <!-- menu เซ็นเซอร์ -->
      <!-- <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button style="background-color: rgba(220,220,220, 0.2);">
          <b-link to="/sensor-total">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-10"
                y="3"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 34C20.5228 34 19.2582 33.4778 18.2062 32.4333C17.1543 31.3889 16.6283 30.1333 16.6283 28.6667C16.6283 27.2 17.1543 25.9444 18.2062 24.9C19.2582 23.8556 20.5228 23.3333 22 23.3333C23.4772 23.3333 24.7418 23.8556 25.7938 24.9C26.8457 25.9444 27.3717 27.2 27.3717 28.6667C27.3717 30.1333 26.8457 31.3889 25.7938 32.4333C24.7418 33.4778 23.4772 34 22 34ZM9.98082 17.4667L8 15.6333C9.81295 13.8778 11.9169 12.5 14.3118 11.5C16.7066 10.5 19.2694 10 22 10C24.7306 10 27.2934 10.5 29.6883 11.5C32.0831 12.5 34.1871 13.8778 36 15.6333L34.0192 17.4667C32.4301 15.9778 30.6171 14.8058 28.5803 13.9507C26.5436 13.0947 24.3501 12.6667 22 12.6667C19.6499 12.6667 17.4564 13.0947 15.4197 13.9507C13.3829 14.8058 11.5699 15.9778 9.98082 17.4667ZM29.1175 22.0333C28.1775 21.1889 27.1031 20.5276 25.8945 20.0493C24.6859 19.572 23.3877 19.3333 22 19.3333C20.6123 19.3333 19.32 19.572 18.123 20.0493C16.9251 20.5276 15.8449 21.1889 14.8825 22.0333L12.9017 20.2C14.1103 19.0889 15.4922 18.2222 17.0473 17.6C18.6033 16.9778 20.2542 16.6667 22 16.6667C23.7458 16.6667 25.3909 16.9778 26.9353 17.6C28.4796 18.2222 29.8561 19.0889 31.0647 20.2L29.1175 22.0333Z"
                    fill="url(#paint0_linear_584_11212)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_584_11212"
                      x1="22"
                      y1="10"
                      x2="22"
                      y2="34"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FDFF13" />
                      <stop
                        offset="1"
                        stop-color="#DDC701"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="65"
                y="13"
                width="120"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>เซ็นเซอร์</strong>
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col> -->

      <!-- menu ระบบไฟประดับ -->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button>
          <b-link to="/bridgelighting-sub?DeptID=9">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-10"
                y="4"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 21.3461C22 21.3461 21.0869 15.6277 21.0869 15.2293C21.0869 14.8309 21.4965 14.5072 22 14.5072C22.5035 14.5072 22.9131 14.8304 22.9131 15.2293C22.9131 15.6283 22 21.3461 22 21.3461ZM22 22.6811C22 22.6811 22.9131 28.3989 22.9131 28.7979C22.9131 29.1968 22.5035 29.52 22 29.52C21.4965 29.52 21.0869 29.1973 21.0869 28.7979C21.0869 28.3984 22 22.6811 22 22.6811ZM21.3323 22.0133C21.3323 22.0133 15.6144 22.9264 15.216 22.9264C14.8171 22.9264 14.4939 22.5173 14.4939 22.0133C14.4939 21.5099 14.8171 21.1008 15.216 21.1008C15.6144 21.1008 21.3323 22.0133 21.3323 22.0133ZM22.6677 22.0133C22.6677 22.0133 28.3856 21.1008 28.7845 21.1008C29.1829 21.1008 29.5067 21.5099 29.5067 22.0133C29.5067 22.5173 29.1835 22.9264 28.7845 22.9264C28.3856 22.9264 22.6677 22.0133 22.6677 22.0133ZM21.5275 21.5419C21.5275 21.5419 16.8389 18.1445 16.5579 17.8624C16.2757 17.5808 16.336 17.0629 16.6928 16.7067C17.0491 16.3504 17.5664 16.2901 17.8485 16.5717C18.1296 16.8533 21.5275 21.5419 21.5275 21.5419ZM22.4725 22.4859C22.4725 22.4859 27.1611 25.8832 27.4421 26.1653C27.7243 26.4475 27.664 26.9648 27.3072 27.3216C26.9509 27.6779 26.4336 27.7381 26.1515 27.456C25.8704 27.1739 22.4725 22.4859 22.4725 22.4859ZM21.5275 22.4859C21.5275 22.4859 18.1296 27.1739 17.8485 27.456C17.5664 27.7381 17.0491 27.6779 16.6928 27.3216C16.336 26.9648 16.2757 26.4475 16.5579 26.1653C16.8389 25.8832 21.5275 22.4859 21.5275 22.4859ZM22.4725 21.5419C22.4725 21.5419 25.8704 16.8533 26.1515 16.5717C26.4336 16.2901 26.9509 16.3504 27.3072 16.7067C27.664 17.0629 27.7243 17.5808 27.4421 17.8624C27.1611 18.1445 22.4725 21.5419 22.4725 21.5419ZM21.5499 20.9003C21.5499 20.9003 16.8485 11.6992 16.5797 11.0336C16.3109 10.368 16.4715 9.67573 16.9387 9.48693C17.4064 9.29813 18.0027 9.6848 18.2715 10.3504C18.5403 11.0149 21.5499 20.9003 21.5499 20.9003ZM22.4501 23.128C22.4501 23.128 27.1515 32.3285 27.4203 32.9947C27.6891 33.6597 27.5285 34.352 27.0613 34.5403C26.5936 34.7296 25.9973 34.3435 25.7285 33.6779C25.4597 33.0123 22.4501 23.128 22.4501 23.128ZM20.8859 22.464C20.8859 22.464 11.6848 27.1653 11.0192 27.4341C10.3536 27.7035 9.66133 27.5424 9.47253 27.0747C9.28373 26.608 9.6704 26.0107 10.336 25.7419C11.0011 25.4731 20.8859 22.464 20.8859 22.464ZM23.1141 21.5637C23.1141 21.5637 32.3152 16.8624 32.9808 16.5936C33.6464 16.3243 34.3387 16.4859 34.5275 16.9531C34.7163 17.4203 34.3296 18.0171 33.664 18.2859C32.9989 18.5541 23.1141 21.5637 23.1141 21.5637ZM20.8939 21.5445C20.8939 21.5445 11.0629 18.3632 10.4027 18.0827C9.7424 17.8027 9.3664 17.1995 9.5632 16.7349C9.76 16.2715 10.456 16.1227 11.1163 16.4032C11.7765 16.6827 20.8939 21.5445 20.8939 21.5445ZM23.1061 22.4832C23.1061 22.4832 32.9371 25.6645 33.5973 25.9445C34.2576 26.2251 34.6336 26.8288 34.4368 27.2923C34.24 27.7568 33.544 27.9056 32.8837 27.6245C32.2235 27.3445 23.1061 22.4832 23.1061 22.4832ZM21.5307 23.12C21.5307 23.12 18.3493 32.9509 18.0688 33.6117C17.7883 34.272 17.1851 34.648 16.7211 34.4512C16.2571 34.2539 16.1088 33.5584 16.3883 32.8981C16.6693 32.2373 21.5307 23.12 21.5307 23.12ZM22.4693 20.9077C22.4693 20.9077 25.6507 11.0768 25.9312 10.4165C26.2117 9.75573 26.8149 9.38027 27.2789 9.57707C27.7429 9.77387 27.8917 10.4688 27.6117 11.1296C27.3307 11.7904 22.4693 20.9077 22.4693 20.9077ZM22.0032 30.0363C22.0032 30.0363 22.9173 36.6944 22.9173 37.1584C22.9173 37.6224 22.5088 38 22.0048 38C21.5008 38 21.0923 37.624 21.0923 37.1595C21.0923 36.6949 22.0032 30.0363 22.0032 30.0363ZM21.9973 13.4427C21.9973 13.4427 21.0827 7.21973 21.0827 6.78613C21.0827 6.35253 21.4912 6 21.9952 6C22.4992 6 22.9077 6.35147 22.9077 6.7856C22.9077 7.21973 21.9973 13.4427 21.9973 13.4427ZM27.6848 27.68C27.6848 27.68 33.0395 31.7419 33.3669 32.0699C33.696 32.3984 33.6731 32.9531 33.3168 33.3099C32.9605 33.6661 32.4053 33.6891 32.0773 33.3611C31.7488 33.0336 27.6848 27.68 27.6848 27.68ZM15.9472 15.9509C15.9472 15.9509 10.9003 12.1973 10.5931 11.8907C10.2864 11.5835 10.3264 11.0459 10.6827 10.6896C11.0389 10.3328 11.5771 10.2928 11.8837 10.6C12.1909 10.9061 15.9472 15.9509 15.9472 15.9509ZM27.6848 16.3195C27.6848 16.3195 31.7488 10.9669 32.0773 10.6389C32.4053 10.3104 32.9605 10.3333 33.3168 10.6901C33.6731 11.0464 33.696 11.6016 33.3669 11.9296C33.0395 12.2571 27.6848 16.3195 27.6848 16.3195ZM15.9472 28.0485C15.9472 28.0485 12.1909 33.0939 11.8837 33.4C11.5771 33.7072 11.0389 33.6667 10.6827 33.3104C10.3264 32.9536 10.2864 32.416 10.5931 32.1093C10.9003 31.8027 15.9472 28.0485 15.9472 28.0485ZM30.0363 21.9968C30.0363 21.9968 36.6944 21.0827 37.1589 21.0827C37.6235 21.0821 38 21.4912 38 21.9947C38.0005 22.4987 37.6245 22.9077 37.16 22.9077C36.6955 22.9083 30.0363 21.9968 30.0363 21.9968ZM13.4432 22.0032C13.4432 22.0032 7.2192 22.9168 6.78613 22.9173C6.35147 22.9173 6 22.5083 6 22.0048C6 21.5008 6.35147 21.0917 6.78613 21.0917C7.2192 21.0917 13.4432 22.0032 13.4432 22.0032Z"
                    fill="url(#paint0_linear_455_21690)"
                  />
                  <path
                    d="M15.9882 8.63259C16.5301 8.63259 16.9695 8.19323 16.9695 7.65126C16.9695 7.10928 16.5301 6.66992 15.9882 6.66992C15.4462 6.66992 15.0068 7.10928 15.0068 7.65126C15.0068 8.19323 15.4462 8.63259 15.9882 8.63259Z"
                    fill="url(#paint1_linear_455_21690)"
                  />
                  <path
                    d="M28.1571 8.63259C28.6991 8.63259 29.1384 8.19323 29.1384 7.65126C29.1384 7.10928 28.6991 6.66992 28.1571 6.66992C27.6151 6.66992 27.1758 7.10928 27.1758 7.65126C27.1758 8.19323 27.6151 8.63259 28.1571 8.63259Z"
                    fill="url(#paint2_linear_455_21690)"
                  />
                  <path
                    d="M15.7114 37.3954C16.2536 37.3954 16.6932 36.9558 16.6932 36.4135C16.6932 35.8712 16.2536 35.4316 15.7114 35.4316C15.1691 35.4316 14.7295 35.8712 14.7295 36.4135C14.7295 36.9558 15.1691 37.3954 15.7114 37.3954Z"
                    fill="url(#paint3_linear_455_21690)"
                  />
                  <path
                    d="M27.8803 37.3954C28.4226 37.3954 28.8622 36.9558 28.8622 36.4135C28.8622 35.8712 28.4226 35.4316 27.8803 35.4316C27.338 35.4316 26.8984 35.8712 26.8984 36.4135C26.8984 36.9558 27.338 37.3954 27.8803 37.3954Z"
                    fill="url(#paint4_linear_455_21690)"
                  />
                  <path
                    d="M7.55262 28.9597C8.0946 28.9597 8.53396 28.5204 8.53396 27.9784C8.53396 27.4364 8.0946 26.9971 7.55262 26.9971C7.01065 26.9971 6.57129 27.4364 6.57129 27.9784C6.57129 28.5204 7.01065 28.9597 7.55262 28.9597Z"
                    fill="url(#paint5_linear_455_21690)"
                  />
                  <path
                    d="M7.55262 16.7908C8.0946 16.7908 8.53396 16.3514 8.53396 15.8095C8.53396 15.2675 8.0946 14.8281 7.55262 14.8281C7.01065 14.8281 6.57129 15.2675 6.57129 15.8095C6.57129 16.3514 7.01065 16.7908 7.55262 16.7908Z"
                    fill="url(#paint6_linear_455_21690)"
                  />
                  <path
                    d="M36.3149 29.2372C36.8571 29.2372 37.2967 28.7976 37.2967 28.2553C37.2967 27.713 36.8571 27.2734 36.3149 27.2734C35.7726 27.2734 35.333 27.713 35.333 28.2553C35.333 28.7976 35.7726 29.2372 36.3149 29.2372Z"
                    fill="url(#paint7_linear_455_21690)"
                  />
                  <path
                    d="M36.3153 17.0681C36.8573 17.0681 37.2967 16.6288 37.2967 16.0868C37.2967 15.5448 36.8573 15.1055 36.3153 15.1055C35.7733 15.1055 35.334 15.5448 35.334 16.0868C35.334 16.6288 35.7733 17.0681 36.3153 17.0681Z"
                    fill="url(#paint8_linear_455_21690)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_455_21690"
                      x1="22"
                      y1="6"
                      x2="22"
                      y2="38"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFC1EE" />
                      <stop
                        offset="0.875"
                        stop-color="#ED72CA"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_455_21690"
                      x1="15.9882"
                      y1="6.66992"
                      x2="15.9882"
                      y2="8.63259"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFC1EE" />
                      <stop
                        offset="0.875"
                        stop-color="#ED72CA"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_455_21690"
                      x1="28.1571"
                      y1="6.66992"
                      x2="28.1571"
                      y2="8.63259"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFC1EE" />
                      <stop
                        offset="0.875"
                        stop-color="#ED72CA"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint3_linear_455_21690"
                      x1="15.7114"
                      y1="35.4316"
                      x2="15.7114"
                      y2="37.3954"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFC1EE" />
                      <stop
                        offset="0.875"
                        stop-color="#ED72CA"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint4_linear_455_21690"
                      x1="27.8803"
                      y1="35.4316"
                      x2="27.8803"
                      y2="37.3954"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFC1EE" />
                      <stop
                        offset="0.875"
                        stop-color="#ED72CA"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint5_linear_455_21690"
                      x1="7.55262"
                      y1="26.9971"
                      x2="7.55262"
                      y2="28.9597"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFC1EE" />
                      <stop
                        offset="0.875"
                        stop-color="#ED72CA"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint6_linear_455_21690"
                      x1="7.55262"
                      y1="14.8281"
                      x2="7.55262"
                      y2="16.7908"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFC1EE" />
                      <stop
                        offset="0.875"
                        stop-color="#ED72CA"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint7_linear_455_21690"
                      x1="36.3149"
                      y1="27.2734"
                      x2="36.3149"
                      y2="29.2372"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFC1EE" />
                      <stop
                        offset="0.875"
                        stop-color="#ED72CA"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint8_linear_455_21690"
                      x1="36.3153"
                      y1="15.1055"
                      x2="36.3153"
                      y2="17.0681"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFC1EE" />
                      <stop
                        offset="0.875"
                        stop-color="#ED72CA"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="65"
                y="13"
                width="120"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>ระบบไฟประดับ</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>

      <!-- menu อุโมงค์ -->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button>
          <b-link to="/tunnel-total">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-10"
                y="10"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="28"
                  height="26"
                  viewBox="0 0 28 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.46154 0C2.89262 0 0 3.13655 0 7.00582V23.6647C0 24.9553 0.964923 26 2.15385 26H4.30769V15.4913C4.30769 9.68618 8.64769 4.98254 14 4.98254C19.3523 4.98254 23.6923 9.68618 23.6923 15.4913V26H25.8462C27.0351 26 28 24.9553 28 23.6647V7.00582C28 3.13655 25.1074 0 21.5385 0H6.46154ZM21.5385 18.9091V16.6589C21.5385 11.4991 18.1634 7.31782 14 7.31782C9.83662 7.31782 6.46154 11.5015 6.46154 16.6589V26L21.5385 18.9091Z"
                    fill="url(#paint0_linear_61_34)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_61_34"
                      x1="14"
                      y1="0"
                      x2="14"
                      y2="26"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#F7F7F7" />
                      <stop
                        offset="0.3125"
                        stop-color="#9B9B9B"
                      />
                      <stop
                        offset="1"
                        stop-color="#2B2746"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="65"
                y="13"
                width="120"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>อุโมงค์</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>

      <!-- menu นับรถทั่วประเทศ -->
      <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button>
          <b-link
            href="https://drr-count.enixma.net/"
            target="_blank"
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-10"
                y="5"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M34.6867 9.16661C34.4965 8.62873 34.1438 8.16332 33.6773 7.83484C33.2109 7.50636 32.6538 7.33107 32.0833 7.33327H11.9167C11.3462 7.33107 10.7891 7.50636 10.3227 7.83484C9.85623 8.16332 9.5035 8.62873 9.31333 9.16661L5.5 20.1666V34.8333C5.5 35.3195 5.69315 35.7858 6.03697 36.1296C6.38079 36.4735 6.8471 36.6666 7.33333 36.6666H9.16667C9.6529 36.6666 10.1192 36.4735 10.463 36.1296C10.8068 35.7858 11 35.3195 11 34.8333V32.9999H20.1667C20.1667 29.5963 21.5187 26.3321 23.9255 23.9254C26.3322 21.5187 29.5964 20.1666 33 20.1666C34.9042 20.1592 36.7851 20.5855 38.5 21.4133V20.1666M11.9167 27.4999C11.3728 27.4999 10.8411 27.3387 10.3888 27.0365C9.93661 26.7343 9.58414 26.3048 9.376 25.8023C9.16786 25.2998 9.1134 24.7469 9.21951 24.2134C9.32562 23.68 9.58753 23.19 9.97212 22.8054C10.3567 22.4208 10.8467 22.1589 11.3802 22.0528C11.9136 21.9467 12.4665 22.0011 12.969 22.2093C13.4715 22.4174 13.901 22.7699 14.2032 23.2221C14.5054 23.6744 14.6667 24.206 14.6667 24.7499C14.6667 25.4793 14.3769 26.1788 13.8612 26.6945C13.3455 27.2102 12.646 27.4999 11.9167 27.4999ZM9.16667 18.3333L11.9167 10.0833H32.0833L34.8333 18.3333H9.16667Z"
                    fill="url(#paint0_linear_323_1232)"
                  />
                  <path
                    d="M25.41 28.794L27.1023 31.7304L24.9615 34.4214L22 29.2933L25.41 28.794ZM34.6923 33.846V31.5527C35.4369 31.2227 35.9615 30.4865 35.9615 29.6149C35.9615 29.1325 35.7923 28.684 35.5131 28.3455L37.18 27.3724C38.0346 26.8731 38.3308 25.7815 37.8315 24.9268L36.6638 22.8958C36.4258 22.4854 36.0351 22.1858 35.5771 22.0621C35.119 21.9385 34.6307 22.0009 34.2185 22.2358L27.3392 26.23C26.5354 26.6785 26.2562 27.7109 26.7215 28.5233L27.9908 30.7234C28.4562 31.5274 29.4969 31.8066 30.3008 31.3412L31.8915 30.4273C32.1031 30.9265 32.5008 31.3327 33 31.5527V33.846C33 34.7769 33.7615 35.5385 34.6923 35.5385H38.9231V33.846H34.6923Z"
                    fill="url(#paint1_linear_323_1232)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_323_1232"
                      x1="22"
                      y1="7.33325"
                      x2="22"
                      y2="36.6666"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#78B6E9" />
                      <stop
                        offset="1"
                        stop-color="#18242E"
                      />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_323_1232"
                      x1="30.4615"
                      y1="22"
                      x2="30.4615"
                      y2="35.5385"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#CCAF61" />
                      <stop
                        offset="1"
                        stop-color="#665731"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="65"
                y="13"
                width="120"
                height="150"
                color="#ffffff"
                font-size="17"
              >
                <div>
                  <strong>นับรถทั่วประเทศ</strong>
                <!-- <em>word wrap</em> -->
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col>

      <!-- menu ระดับน้ำ -->
      <!-- <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button style="background-color: rgba(4, 4, 4, 0.2);">
          <b-link to="#">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                x="-10"
                y="3"
                width="100"
                height="150"
                font-size="18"
              >
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.4444 9C12.1563 9 11.1111 10.0917 11.1111 11.4373V21.999H10.3333C9.04514 21.999 8 23.0907 8 24.4363V29.311C8 29.7172 8.09722 30.1031 8.2625 30.4382C8.44722 30.3519 8.64167 30.2808 8.84583 30.2301C9.48264 30.0726 10.1438 29.7324 10.659 29.2856C11.7382 28.3361 13.2986 28.265 14.4556 29.1129C15.3306 29.7426 16.4049 30.1437 17.3333 30.1437C18.359 30.1437 19.375 29.7121 20.2111 29.1129C21.2854 28.3259 22.7194 28.3259 23.7937 29.1129C24.6882 29.7578 25.7188 30.1437 26.6715 30.1437C27.5951 30.1437 28.6743 29.7426 29.5493 29.1129C30.7062 28.265 32.2618 28.3361 33.3458 29.2856C33.8611 29.7324 34.5222 30.0777 35.159 30.2301C35.3632 30.2808 35.5576 30.3519 35.7424 30.4382C35.9028 30.1031 36 29.7172 36 29.311V24.4363C36 23.0907 34.9549 21.999 33.6667 21.999H31.3333V14.55L32.5681 15.8397C33.1757 16.4744 34.1625 16.4744 34.7701 15.8397C35.3778 15.205 35.3778 14.1742 34.7701 13.5395L30.8813 9.47731C30.2736 8.84259 29.2868 8.84259 28.6792 9.47731L24.7903 13.5395C24.1826 14.1742 24.1826 15.205 24.7903 15.8397C25.3979 16.4744 26.3847 16.4744 26.9924 15.8397L28.2222 14.55V21.999H22V11.4373C22 10.0917 20.9549 9 19.6667 9H13.4444ZM22.8993 30.423C22.3597 30.0219 21.6403 30.0219 21.1007 30.423C20.0069 31.2101 18.6701 31.7483 17.3333 31.7483C16.0257 31.7483 14.6451 31.1999 13.5708 30.423C12.9924 29.9914 12.2049 30.0269 11.6653 30.5093C10.9653 31.1136 10.0854 31.5757 9.20556 31.7889C8.36944 31.992 7.84931 32.8654 8.04375 33.7388C8.23819 34.6121 9.07431 35.1555 9.91042 34.9524C11.1014 34.6629 12.0931 34.1145 12.7396 33.6829C14.1493 34.475 15.7292 34.9981 17.3333 34.9981C18.884 34.9981 20.2792 34.4954 21.2417 34.0384C21.5236 33.9013 21.7813 33.7692 22 33.6474C22.2188 33.7692 22.4715 33.9063 22.7583 34.0384C23.7208 34.4954 25.1208 34.9981 26.6667 34.9981C28.2708 34.9981 29.8507 34.475 31.2604 33.688C31.9118 34.1145 32.8986 34.668 34.0896 34.9574C34.9257 35.1605 35.7618 34.6172 35.9562 33.7439C36.1507 32.8705 35.6306 31.9971 34.7944 31.794C33.9146 31.5807 33.0347 31.1187 32.3347 30.5144C31.7951 30.0371 31.0076 30.0016 30.4292 30.4281C29.3597 31.1999 27.9743 31.7483 26.6667 31.7483C25.3299 31.7483 23.9931 31.2101 22.8993 30.423V30.423Z"
                    fill="url(#paint0_linear_584_11196)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_584_11196"
                      x1="22"
                      y1="9"
                      x2="22"
                      y2="35"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#99E3FB" />
                      <stop
                        offset="0.619792"
                        stop-color="#039ADB"
                      />
                    </linearGradient>
                  </defs>
                </svg>

              </foreignObject>
              <foreignObject
                x="65"
                y="13"
                width="120"
                height="150"
                color="#D3D3D3"
                font-size="17"
              >
                <div>
                  <strong>ระดับน้ำ</strong>
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col> -->

      <!-- menu Report -->
      <!-- <b-col
        xl="2"
        lg="3"
        md="4"
        sm="6"
        xs="6"
        class="hero-text mb-1"
      >
        <button>
          <b-link to="#">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 194 51"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M193 9.5V4.5L189.571 1H4.42857L1 4.5V9.5"
                stroke="#00B058"
              />
              <path
                d="M193 41.5V46.5L189.571 50H4.42857L1 46.5V41.5"
                stroke="#00B058"
              />
              <path
                d="M193 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <path
                d="M1 11.5V39.5"
                stroke="#00B058"
                stroke-width="2"
              />
              <foreignObject
                width="100%"
                height="100%"
                x="-55"
                y="5"
              >
                <div>
                  <b-img
                    height="40"
                    src="@/assets/images/icons/report/iconreport.png"
                  />
                </div>
              </foreignObject>
              <foreignObject
                x="60"
                y="13"
                width="120"
                height="150"
                color="#D3D3D3"
                font-size="17"
              >
                <div>
                  <strong>รายงาน</strong>
                </div>
              </foreignObject>
            </svg>
          </b-link>
        </button>
      </b-col> -->
    </b-row>
  </div>

</template>

<script>
import {
  BRow, BCol, BLink, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BImg,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      owner: '',
    }
  },
  created() {
    this.owner = this.userData.groupname
  },
}
</script>

<style scoped>
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
  .text2 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }

  .hero-text button {
    border: none;
    outline: 0;
    display: inline-block;
    padding: 0px 0px;
    border-radius: 7px 7px 7px 7px;
    color: black;
    background-color: rgb(0, 0, 0, 0.0);
    text-align: center;
    cursor: pointer;
    /* width: 193px; */
  }
  .hero-text button:hover {
    background-color: rgb(0, 123, 62);
    color: white;
  }
  </style>
